import { createContext, useContext } from 'react';
const RowContext = createContext({
    onRowClick: () => { },
    isRowDisabled: () => false,
    selectedItems: new Map(),
    getItemData: {},
    columns: [],
    selectLimit: null,
    enableSelection: true,
});
export const { Provider } = RowContext;
export const useRowContext = () => useContext(RowContext);
//# sourceMappingURL=RowContext.js.map